type CrossGlowShapeProps = {
  uid: string
}

const CROSS_PATH =
  'M478 100C547.588 100 604 156.412 604 226C604 315.095 640.905 352 730 352C799.588 352 856 408.412 856 478C856 512.818 841.876 544.337 819.047 567.143C793.029 593.186 793.016 614.775 819.003 640.813C841.859 663.622 856 695.159 856 730C856 799.588 799.588 856 730 856C660.412 856 604 799.588 604 730C604 640.905 567.095 604 478 604C388.905 604 352 640.905 352 730C352 799.588 295.588 856 226 856C156.412 856 100 799.588 100 730C100 695.182 114.122 663.661 136.951 640.856C162.999 614.782 162.984 593.175 136.904 567.096C114.103 544.294 100 512.794 100 478C100 408.412 156.412 352 226 352C315.095 352 352 315.095 352 226C352 156.412 408.412 100 478 100Z'

const NOISE_TABLE_1 =
  '1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0'

const NOISE_TABLE_2 =
  '0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1'

export const CrossGlowShape = ({uid}: CrossGlowShapeProps) => (
  <svg className="h-auto w-full overflow-visible" fill="none" viewBox="0 0 956 956" xmlns="http://www.w3.org/2000/svg">
    <g filter={`url(#filter0_fn_${uid})`}>
      <path clipRule="evenodd" d={CROSS_PATH} fill={`url(#paint0_radial_${uid})`} fillRule="evenodd" />
      <path
        clipRule="evenodd"
        d={CROSS_PATH}
        fill={`url(#paint1_radial_${uid})`}
        fillOpacity="0.3"
        fillRule="evenodd"
      />
    </g>
    <defs>
      <filter
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
        height="956"
        id={`filter0_fn_${uid}`}
        width="956"
        x="0"
        y="0"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" mode="normal" result="shape" />
        <feGaussianBlur result={`effect1_foregroundBlur_${uid}`} stdDeviation="24" />
        <feTurbulence
          baseFrequency="1.2286956310272217 1.2286956310272217"
          numOctaves="3"
          result="noise"
          seed="2512"
          stitchTiles="stitch"
          type="fractalNoise"
        />
        <feColorMatrix in="noise" result="alphaNoise" type="luminanceToAlpha" />
        <feComponentTransfer in="alphaNoise" result="coloredNoise1">
          <feFuncA tableValues={NOISE_TABLE_1} type="discrete" />
        </feComponentTransfer>
        <feComposite in="coloredNoise1" in2={`effect1_foregroundBlur_${uid}`} operator="in" result="noise1Clipped" />
        <feComponentTransfer in="alphaNoise" result="coloredNoise2">
          <feFuncA tableValues={NOISE_TABLE_2} type="discrete" />
        </feComponentTransfer>
        <feComposite in="coloredNoise2" in2={`effect1_foregroundBlur_${uid}`} operator="in" result="noise2Clipped" />
        <feFlood floodColor="rgba(0, 36, 20, 0.5)" result="color1Flood" />
        <feComposite in="color1Flood" in2="noise1Clipped" operator="in" result="color1" />
        <feFlood floodColor="rgba(255, 255, 255, 0.5)" result="color2Flood" />
        <feComposite in="color2Flood" in2="noise2Clipped" operator="in" result="color2" />
        <feMerge result={`effect2_noise_${uid}`}>
          <feMergeNode in={`effect1_foregroundBlur_${uid}`} />
          <feMergeNode in="color1" />
          <feMergeNode in="color2" />
        </feMerge>
      </filter>
      <radialGradient
        cx="0"
        cy="0"
        gradientTransform="matrix(340 264 -264.157 340.321 160 189)"
        gradientUnits="userSpaceOnUse"
        id={`paint0_radial_${uid}`}
        r="1"
      >
        <stop stopColor="#B9FF3F" />
        <stop offset="1" stopColor="#B9FF3F" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        cx="0"
        cy="0"
        gradientTransform="matrix(13.6529 541.852 -544.5 11.5019 380 100)"
        gradientUnits="userSpaceOnUse"
        id={`paint1_radial_${uid}`}
        r="1"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </radialGradient>
    </defs>
  </svg>
)
